import styled from 'styled-components';
import { Color } from 'modules/styles/colors';
import { Spacing } from 'modules/styles/variables';
import { MuiBox } from 'theme/material-ui';

export const AlertBody = styled(MuiBox)`
  padding: ${Spacing.large}px;
  z-index: 2;
`;

export const AlertCard = styled.div`
  position: relative;
  display: block;
  border-radius: 6px;
  padding: 0px;
  background-color: ${Color.white};
  box-shadow: -1px 3px 5px 1px rgba(0, 0, 0, 0.1);
  border: 1px solid ${Color.grayLight};
  margin-bottom: ${Spacing.large}px;
`;

export const AlertTop = styled.div`
  width: 100%;
  height: 20px;
  background-color: ${Color.darkOrangeShade};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

export const AlertSide = styled.div`
  width: ${Spacing.large}px;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background-color: ${Color.error};
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  position: absolute;
  top: 2px;
  left: 0;
  display: block;
  border-radius: 4px;
  border: 1px solid ${Color.primary};
  background-color: ${Color.primary};
`;

export const AlertDotBox = styled.div`
  position: relative;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 8px;
`;
